import React from 'react'
import { Form, Field } from 'react-final-form'
import Button from '@material-ui/core/Button'
import MenuItem from '@material-ui/core/MenuItem'
import { injectIntl } from 'react-intl'
import { Select } from 'components/common/FormInputs'
import Input from 'components/common/Form/Input'
import TextArea from 'components/common/Form/TextArea'
import getValidator, { VALIDATOR_EMAIL, VALIDATOR_IS_EMPTY } from 'validation'
import messages from './translate'

function FeedbackForm(props) {
  const {
    onSubmit,
    intl: { formatMessage },
  } = props
  const typeList = [
    { id: 'feedback_type_ideas', name: 'feedbackTypeIdeas' },
    { id: 'feedback_type_bugs', name: 'feedbackTypeBugs' },
    { id: 'feedback_type_other', name: 'feedbackTypeOther' },
  ]

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        email: null,
        type: null,
        comment: null,
      }}
      render={({ handleSubmit, submitting, pristine }) => (
        <form onSubmit={handleSubmit} className="form-basic">
          <div className="form-group">
            <Field
              name="email"
              type="email"
              label={formatMessage(messages.email)}
              component={Input}
              disabled={submitting}
              validate={getValidator([VALIDATOR_IS_EMPTY, VALIDATOR_EMAIL])}
            />
          </div>
          <div className="form-group">
            <Field
              name="type"
              label={formatMessage(messages.feedbackType)}
              component={Select}
              disabled={submitting}
              validate={getValidator([VALIDATOR_IS_EMPTY])}
              formControlProps={{ fullWidth: true }}>
              {typeList.map(type => (
                <MenuItem component="li" button key={type.id} value={type.id}>
                  {formatMessage(messages[type.name])}
                </MenuItem>
              ))}
            </Field>
          </div>
          <div className="form-group">
            <Field
              name="comment"
              label={formatMessage(messages.comment)}
              component={TextArea}
              validate={getValidator([VALIDATOR_IS_EMPTY])}
              inputProps={{
                maxLength: 750,
              }}
              multiline
            />
          </div>
          <div className="form-group">
            <Button
              href={null}
              type="submit"
              color="primary"
              variant="contained"
              onClick={handleSubmit}
              disabled={submitting || pristine}>
              {formatMessage(messages.send)}
            </Button>
          </div>
        </form>
      )}
    />
  )
}

export default injectIntl(FeedbackForm)
